import React from "react";
import { motion } from "framer-motion";
import { FaGooglePlay, FaApple } from "react-icons/fa";
import "./App.css";

const ANDROID_LINK =
  "https://play.google.com/store/apps/details?id=com.oocloud.oosocial";
const IOS_LINK =
  "https://apps.apple.com/us/app/choice-make-your-mood/id6739964274";

const powerCards = [
  {
    label: "Creator",
    value: "248.40",
    level: "Lv 3",
    accent: "fire-red",
    progress: "48%",
    meta: "Earned from engagement on your content.",
  },
  {
    label: "Explorer",
    value: "186.20",
    level: "Lv 2",
    accent: "fire-orange",
    progress: "86%",
    meta: "Earned from activity across the platform.",
  },
  {
    label: "Tokens",
    value: "435",
    level: "Live",
    accent: "fire-gold",
    progress: "100%",
    meta: "Generated from your total FirePower momentum.",
  },
];

function App() {
  return (
    <main className="app-shell">
      <div className="ambient ambient-left" />
      <div className="ambient ambient-right" />

      <motion.section
        className="hero-panel"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: "easeOut" }}
      >
        <motion.div
          className="brand-block"
          initial={{ opacity: 0, scale: 0.96 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.1, ease: "easeOut" }}
        >
          <img
            src="/assets/icon.png"
            alt="choice app icon"
            className="app-icon"
          />

          <div className="eyebrow">FirePower Driven</div>
          <h1 className="hero-title">choice: Play &amp; Earn</h1>
          <p className="hero-copy">
            Create, compete, and earn inside a social experience where your
            activity builds momentum, grows your score, and turns engagement
            into real progress.
          </p>

          <div className="store-buttons">
            <a
              href={IOS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="store-button store-button-light"
            >
              <FaApple size={20} />
              <span>App Store</span>
            </a>

            <a
              href={ANDROID_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="store-button store-button-dark"
            >
              <FaGooglePlay size={18} />
              <span>Google Play</span>
            </a>
          </div>
        </motion.div>

        <motion.div
          className="power-grid"
          initial="hidden"
          animate="visible"
          variants={{
            visible: {
              transition: {
                staggerChildren: 0.12,
              },
            },
          }}
        >
          {powerCards.map((card) => (
            <motion.article
              key={card.label}
              className={`power-card ${card.accent}`}
              variants={{
                hidden: { opacity: 0, y: 18 },
                visible: { opacity: 1, y: 0 },
              }}
              transition={{ duration: 0.45, ease: "easeOut" }}
            >
              <div className="card-top">
                <div>
                  <div className="card-label">{card.label}</div>
                  <div className="card-value">{card.value}</div>
                </div>
                <div className={`level-pill ${card.accent}`}>{card.level}</div>
              </div>

              <div className="track-shell">
                <div
                  className={`track-fill ${card.accent}`}
                  style={{ width: card.progress }}
                />
                <div className="track-sheen" />
              </div>

              <div className="track-caption">
                <span>{card.progress} charged</span>
                <span>{card.level}</span>
              </div>

              <p className="card-meta">{card.meta}</p>
            </motion.article>
          ))}
        </motion.div>
      </motion.section>
    </main>
  );
}

export default App;
